/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description mutate hook for retry payment
 */
import { useMutation, useQueryClient, UseMutationResult } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Mutate for retry payment
 *
 */
const useRetryPayment = (): UseMutationResult<unknown, IAxiosError, { invoiceId: string }, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (params) => {
			await api.Subscriptions.retryPayment(params);
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess();
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.invoiceHistory] });
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useRetryPayment;
